import { render } from "./index.vue?vue&type=template&id=98370240&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=98370240&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-98370240"

export default script